"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
var Button = _styledComponents["default"].button(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  color: #fff;\n  width: ", ";\n  min-width: 100px;\n  font-size: ", ";\n  border: none;\n  border-radius: 4px;\n  padding: 0.7em 1.7em;\n  margin: 10px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  cursor: pointer;\n  float: ", ";\n  background-color: ", ";\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  button[disabled=disabled],\n  &:disabled {\n    cursor: default;\n    background-color: #ccc;\n  }\n"])), function (_ref) {
  var width = _ref.width;
  return width;
}, function (_ref2) {
  var size = _ref2.size;
  return size === 'small' ? '0.7em' : size === 'medium' ? '0.8em' : size === 'large' ? '0.9em' : '0.8em';
}, function (_ref3) {
  var _float = _ref3["float"];
  return _float;
}, function (_ref4) {
  var _theme$colors;
  var color = _ref4.color,
    theme = _ref4.theme;
  return color === 'green' ? '#1EA659' : color === 'navigationBack' ? (theme === null || theme === void 0 || (_theme$colors = theme.colors) === null || _theme$colors === void 0 || (_theme$colors = _theme$colors.button) === null || _theme$colors === void 0 ? void 0 : _theme$colors["default"]) || '#474747' : '#1EA659';
}, function (_ref5) {
  var _theme$colors2;
  var color = _ref5.color,
    theme = _ref5.theme;
  return color === 'green' ? '#23BF66' : color === 'navigationBack' ? (theme === null || theme === void 0 || (_theme$colors2 = theme.colors) === null || _theme$colors2 === void 0 || (_theme$colors2 = _theme$colors2['button:hovered']) === null || _theme$colors2 === void 0 ? void 0 : _theme$colors2["default"]) || '#898989' : '#23BF66';
});
Button.propTypes = {
  color: _propTypes["default"].string,
  size: _propTypes["default"].string,
  width: _propTypes["default"].string,
  "float": _propTypes["default"].string
}, Button.defaultProps = {
  width: 'auto',
  "float": 'none'
};
var _default = exports["default"] = Button;